module.exports = __webpack_public_path__ + "static/media/peterArt3.3126a3f2.jpg";